import { combineReducers } from 'redux';

import medicalHistory from './medicalHistory/reducer';
import teleconsult from './teleconsult/reducer';
import companies from './companies/reducer';
import prescription from './prescription/reducer';

export default combineReducers({
  medicalHistory,
  teleconsult,
  companies,
  prescription,
});
